import React, { createContext, useContext, useState, ReactNode } from "react";

interface ShippingContextType {
  zipCode: string;
  setZipCode: (zipCode: string) => void;
  selectedShippingOptionId: string | null;
  setSelectedShippingOptionId: (optionId: string | null) => void;
  selectedShippingOptionBranchId: string | null;
  setSelectedShippingOptionBranchId: (optionBranchId: string | null) => void;
  clearShippingData: () => void;
}

const ShippingContext = createContext<ShippingContextType | undefined>(undefined);

interface ShippingProviderProps {
  children: ReactNode;
}

export const ShippingProvider: React.FC<ShippingProviderProps> = ({ children }) => {
  const [zipCode, setZipCode] = useState<string>("");
  const [selectedShippingOptionId, setSelectedShippingOptionId] = useState<string | null>(null);
  const [selectedShippingOptionBranchId, setSelectedShippingOptionBranchId] = useState<string | null>(null);

  const clearShippingData = () => {
    setZipCode("");
    setSelectedShippingOptionId(null);
    setSelectedShippingOptionBranchId(null);
  };

  return (
    <ShippingContext.Provider
      value={{
        zipCode,
        setZipCode,
        selectedShippingOptionId,
        setSelectedShippingOptionId,
        selectedShippingOptionBranchId,
        setSelectedShippingOptionBranchId,
        clearShippingData,
      }}
    >
      {children}
    </ShippingContext.Provider>
  );
};

export const useShipping = (): ShippingContextType => {
  const context = useContext(ShippingContext);
  if (!context) {
    throw new Error("useShipping must be used within a ShippingProvider");
  }
  return context;
};

export const useOptionalShipping = (): ShippingContextType | undefined => {
  return useContext(ShippingContext);
};

